import React, { FC } from 'react';
import { FlightFragment } from '@websky/graphql';
import Flight from '../../../../../Flight';
import { checkoutSegmentGroupToFlightPropsAdapter } from '../../../../../Flight/adapters';
import { OverrideComponent } from '../../../../../renderProps';
import { ThemeProvider, useTheme } from '../../../../../theme';

interface Props {
	orderId: string;
	flight: FlightFragment;
}

const ExchangeRefundFlights: FC<Props> = ({ orderId, flight }) => {
	const { ExchangeRefundFlights: theme } = useTheme('Entities').Order;

	return (
		<div className={theme.root}>
			<ThemeProvider
				value={{
					DesktopFlightRoute: {
						DesktopFlightRouteStyles: {
							flight: theme.flight,
							selected: theme.selected
						}
					},
					MobileFlight: {
						FlightStyles: {
							flight: theme.flight,
							flight_selected: theme.selected
						}
					}
				}}
			>
				{flight.segmentGroups.map((group, index) => {
					return (
						<OverrideComponent<React.ComponentProps<typeof Flight>>
							key={index}
							componentProps={{
								...checkoutSegmentGroupToFlightPropsAdapter(
									orderId,
									flight,
									flight.segmentGroups.find(segmentGroup => segmentGroup.groupId === group.groupId)
								)
							}}
							component={{
								renderCheckoutSelectedFlight: Flight
							}}
						/>
					);
				})}
			</ThemeProvider>
		</div>
	);
};

export default ExchangeRefundFlights;
